"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionControllerSection = void 0;
const compressFormQuestion_1 = __importDefault(require("../../compress/compressFormQuestion"));
const FormQuestionType_1 = __importDefault(require("../../FormQuestionType"));
const formQuestionsAreSame_1 = __importDefault(require("../../helpers/formQuestionsAreSame"));
const getQuestionConfig_1 = __importDefault(require("../../helpers/getQuestionConfig"));
const createFormQuestion_1 = __importDefault(require("../../mutations/createFormQuestion"));
const createFormQuestionConfigBase_1 = __importDefault(require("../../mutations/createFormQuestionConfigBase"));
const DefaultFormQuestionController_1 = __importDefault(require("../DefaultFormQuestionController"));
exports.QuestionControllerSection = Object.assign(Object.assign({}, DefaultFormQuestionController_1.default), { areSame: (a, b) => {
        if (a.type !== FormQuestionType_1.default.SECTION || b.type !== FormQuestionType_1.default.SECTION)
            return false;
        if (!DefaultFormQuestionController_1.default.areSame(a, b))
            return false;
        const aConfig = a.config[FormQuestionType_1.default.SECTION];
        const bConfig = b.config[FormQuestionType_1.default.SECTION];
        return (0, formQuestionsAreSame_1.default)(aConfig.questions, bConfig.questions);
    }, compress: (q) => {
        const config = (0, getQuestionConfig_1.default)(FormQuestionType_1.default.SECTION, q);
        return {
            [FormQuestionType_1.default.SECTION]: Object.assign(Object.assign({}, config), { questions: config.questions.map(compressFormQuestion_1.default) }),
        };
    }, canScore: () => {
        return false;
    }, createConfig: (o = {}) => {
        return Object.assign(Object.assign(Object.assign({}, (0, createFormQuestionConfigBase_1.default)({ scoring: exports.QuestionControllerSection.canScore() })), (o || {})), { questions: ((o === null || o === void 0 ? void 0 : o.questions) || []).map(q => (0, createFormQuestion_1.default)(q)) });
    }, createExampleConfig: () => {
        return exports.QuestionControllerSection.createConfig({
            questions: [],
        });
    } });
exports.default = exports.QuestionControllerSection;
